import Vue from 'vue'
import AuthModule from '@/components/Auth'
import { Base64 } from 'js-base64';


Vue.use(AuthModule)
Vue.prototype.$auth = AuthModule
Vue.prototype.$SignIn = AuthModule.SignIn
Vue.prototype.$Register = AuthModule.Register

Vue.use(Base64);
Vue.prototype.$Base64 = Base64;
